import { FC } from 'react';
import { IRTERenderElementProps } from '../../../../../../RTEEditable.interfaces';

export const TableBodyElement: FC<IRTERenderElementProps> = (props) => {
  const { children } = props;
  const attributes = props.attributes ?? {};

  return <tbody {...attributes}>{children}</tbody>;
};
